import { render, staticRenderFns } from "./StaffHoursTable.vue?vue&type=template&id=32d2004b&"
import script from "./StaffHoursTable.vue?vue&type=script&lang=js&"
export * from "./StaffHoursTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports